import React, { useState } from 'react';
import './Careers.css';

const jobData = [
  {
    title: 'Frontend Developer',
    description: 'Work on exciting UI/UX projects with modern React and Tailwind.',
  },
  {
    title: 'Backend Engineer',
    description: 'Build scalable backend APIs using Node.js and MongoDB.',
  },
  {
    title: 'AI/ML Research Intern',
    description: 'Join our AI team and contribute to real-world machine learning models.',
  },
  {
    title: 'Cybersecurity Analyst',
    description: 'Analyze threats and design secure systems using the latest techniques.',
  },
  {
    title: 'Java Developer',
    description: 'Develop enterprise-grade Java applications using Spring Boot and REST APIs.',
  },
  {
    title: 'Power BI Analyst',
    description: 'Create compelling dashboards and business intelligence reports using Power BI.',
  },
  {
    title: 'Data Science Intern',
    description: 'Support our data team in cleaning, analyzing, and visualizing datasets.',
  },
  {
    title: 'MERN Stack Developer',
    description: 'Build full-stack applications with MongoDB, Express, React, and Node.js.',
  },
];

const ContactForm = ({ jobTitle }) => (
  <form className="contact-form">
    <h3>Apply for {jobTitle}</h3>
    <input type="text" placeholder="Your Name" required />
    <input type="email" placeholder="Your Email" required />
    <input type="text" placeholder="Phone Number" required />
    <input type="file" accept=".pdf,.doc,.docx" required />
    <textarea placeholder="Why should we hire you?" required></textarea>
    <button type="submit">Submit Application</button>
  </form>
);

const Careers = () => {
  const [activeFormIndex, setActiveFormIndex] = useState(null);

  return (
    <div className="careers-page">
      <div className="main-heading">
        <h1>🎓 Join Our Amazing Internship</h1>
        <h2 className="location-heading"> Company based in Pune | Available Online & Offline</h2>
      </div>

      <div className="jobs-container">
        {jobData.map((job, index) => (
          <div key={index} className="job-block">
            <h2>{job.title}</h2>
            <p className="job-description">{job.description}</p>
            <button
              className="apply-button"
              onClick={() =>
                setActiveFormIndex(activeFormIndex === index ? null : index)
              }
            >
              {activeFormIndex === index ? "Close Form" : "Apply Now"}
            </button>

            {activeFormIndex === index && <ContactForm jobTitle={job.title} />}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Careers;
